import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";

export const DashboardCard = ({ children, sx }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        backgroundColor: colors.primary[400],
        borderRadius: "12px",
        border: `1px solid ${theme.palette.divider}`,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export const ChartCard = ({ title, icon, children, gridColumn, gridRow }) => (
  <DashboardCard
    sx={{
      gridColumn,
      gridRow,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      minHeight: 0,
      maxHeight: "100%",
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 2,
        pt: 2,
        pb: 0.5,
        flexShrink: 0,
      }}
    >
      {icon}
      <Typography variant="h5" fontWeight={700}>
        {title}
      </Typography>
    </Box>
    <Box sx={{ height: 250, minHeight: 250, maxHeight: 250, px: 1, pb: 1 }}>
      {children}
    </Box>
  </DashboardCard>
);
